import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { spinnerTypes } from '@Containers/GlobalSpinner/GlobalSpinnerConstants';
import { compose } from 'redux';
import { List } from 'immutable';

const alertsLoad = (Component) => {
  function AlertLoadHOC(props) {
    const [statusMessage, setStatusMessage] = useState('');
    const {
      alertsIds,
      fetchAlerts,
      showGlobalSpinner,
      hideGlobalSpinner,
      setMounted,
      refetch,
      setRefetch,
      processPageAlertsByAlertId,
      isGlobalSpinnerShown,
    } = props;

    useEffect(() => {
      setMounted(true);

      const fetchData = async () => {
        if (!alertsIds || refetch) {
          setStatusMessage('Loading alerts.');
          showGlobalSpinner(spinnerTypes.progress);
          const alerts = await fetchAlerts(refetch);
          if (Array.isArray(alerts)) {
            processPageAlertsByAlertId(alerts);
            const alertLabel = alerts.length === 1 ? 'alert' : 'alerts';
            setStatusMessage(alerts.length === 0 ? 'No alerts found.' : `${alerts.length} ${alertLabel} loaded.`);
          } else {
            setStatusMessage('Unable to load alerts.');
          }
          hideGlobalSpinner();
          if (refetch) {
            setRefetch(false);
          }
        }
      };

      fetchData();

      return () => {
        setMounted(false);
        if (isGlobalSpinnerShown) {
          hideGlobalSpinner();
        }
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [alertsIds]);

    return <Component {...props} statusMessage={statusMessage} setStatusMessage={setStatusMessage} />;
  }

  AlertLoadHOC.propTypes = {
    alertsIds: PropTypes.instanceOf(List),
    fetchAlerts: PropTypes.func,
    showGlobalSpinner: PropTypes.func,
    hideGlobalSpinner: PropTypes.func,
    setMounted: PropTypes.func,
    refetch: PropTypes.bool,
    setRefetch: PropTypes.func,
    processPageAlertsByAlertId: PropTypes.func,
    isGlobalSpinnerShown: PropTypes.bool,
  };

  return AlertLoadHOC;
};

const alertloadComposed = compose(alertsLoad);
export default alertloadComposed;
